"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWeblabStore = exports.WeblabContainer = exports.WeblabSubscriber = exports.weblabStore = exports.WEBLAB_STORE_NAME = void 0;
const react_sweet_state_1 = require("react-sweet-state");
const actions_1 = require("./actions");
const state_1 = require("./state");
exports.WEBLAB_STORE_NAME = 'monera-weblab-store';
exports.weblabStore = (0, react_sweet_state_1.createStore)({
    actions: actions_1.weblabActions,
    initialState: state_1.initialWeblabState,
    name: exports.WEBLAB_STORE_NAME
});
exports.WeblabSubscriber = (0, react_sweet_state_1.createSubscriber)(exports.weblabStore);
exports.WeblabContainer = (0, react_sweet_state_1.createContainer)(exports.weblabStore, {
    onInit: () => ({ setState }, { initialState }) => setState(initialState !== null && initialState !== void 0 ? initialState : state_1.initialWeblabState),
    onUpdate: () => ({ setState }, { initialState }) => setState(initialState !== null && initialState !== void 0 ? initialState : state_1.initialWeblabState)
});
exports.useWeblabStore = (0, react_sweet_state_1.createHook)(exports.weblabStore);
__exportStar(require("./types"), exports);
